export default function basket() {
    const checkoutButtons = document.querySelectorAll('[data-go-checkout-button]');
    const backToTop = document.querySelector('[data-back-to-top]');
    const header = document.querySelector('#header');
    document.querySelectorAll('[data-network-switching-available-dates]')
        .forEach((select) => {
            select.addEventListener('change', (event) => {
                const id = event.target.id;
                const match = id.match(/deal-(\d+)/);
                if (match) {
                    const publicId = 'deal-' + match[1];
                    $.ajax({
                        type: 'POST',
                        url: '/basket/network-switching/add-date',
                        data: {
                            dateVal: event.target.value,
                            publicId: publicId
                        },
                        dataType: 'JSON'
                    });
                }
            });
        });
    // Shared validators. Return true if the click/submit should be blocked.
    const hasBillCappingOrAccessibilityErrors = () => {
        let hasErrors = false;
        // Check bill capping sections
        document.querySelectorAll('[data-bill-capping-basket-section]').forEach((section) => {
            const decisionInputs = section.querySelectorAll('[data-bill-capping-decision] input[type="radio"]');
            const decisionRadioYes = Array.from(decisionInputs).find(input => input.value === '1');
            const amountSelect = section.querySelector('[data-bill-capping-amount]');

            if (decisionRadioYes && decisionRadioYes.checked && amountSelect) {
                if (!amountSelect.value || amountSelect.value === '') {
                    hasErrors = true;
                }
            }
        });

        // Check accessibility sections
        document.querySelectorAll('[data-accessibility-basket-section]').forEach((section) => {
            const decisionInputs = section.querySelectorAll('[data-accessibility-decision] input[type="radio"]');
            const decisionRadioYes = Array.from(decisionInputs).find(input => input.value === '1');
            const thirdPartySelect = section.querySelector('[data-accessibility-third-party-code]');

            if (decisionRadioYes && decisionRadioYes.checked && thirdPartySelect) {
                if (!thirdPartySelect.value || thirdPartySelect.value === '') {
                    hasErrors = true;
                }
            }
        });
        return hasErrors;
    };
    // CPW: If a network-switching form has PAC/STAC/phone values typed
    // but the user never clicked "Validate" (the date dropdown hasn't
    // been populated yet), surface the validate-error message and
    // return true to block checkout.
    const hasNetworkSwitchingNotValidated = () => {
        let blocked = false;
        const nsForms = document.querySelectorAll('[data-network-switching]');
        nsForms.forEach((nsForm) => {
            if (nsForm.dataset.networkSwitchingChoice === 'no') {
                return;
            }
            // Click & Collect baskets have no date dropdown — once the
            // network-switching form has transitioned to the validated
            // 'edit' state, treat it as complete and don't block submit.
            if (nsForm.getAttribute('data-network-switching-cc') === 'true'
                && nsForm.dataset.networkSwitchingFormState === 'edit') {
                return;
            }
            const pac = nsForm.querySelector('[data-network-switching-type="pac"]');
            const stac = nsForm.querySelector('[data-network-switching-type="stac"]');
            const phone = nsForm.querySelector('[data-network-switching-phone-number]');
            const hasTypedValue = (pac && pac.value) || (stac && stac.value) || (phone && phone.value);
            if (!hasTypedValue) {
                return;
            }
            const dateSelect = nsForm.querySelector('[data-network-switching-available-dates]');
            const optionCount = dateSelect ? dateSelect.querySelectorAll('option').length : 0;
            const hasValidated = dateSelect && optionCount > 1;

            // Case A: validated and dropdown populated but user hasn't picked a date.
            // On /basket page (.buttonSubmitSidebar exists) the date is not required yet —
            // it's entered on /basket/details, so don't block here.
            if (hasValidated && (!dateSelect.value || dateSelect.value === '')
                && !document.querySelector('.buttonSubmitSidebar')) {
                const dateSection = dateSelect.closest('[data-network-switching-date]');
                const dateError = (dateSection && dateSection.querySelector(`#error-${dateSelect.id}`))
                    || (dateSection && dateSection.querySelector('.help-block'))
                    || nsForm.querySelector('[data-network-switching-date] .help-block');
                if (dateError) {
                    dateError.style.display = 'inline';
                    dateError.removeAttribute('hidden');
                    dateError.classList.add('is-invalid');
                }
                const dateGroup = dateSelect.closest('.form-group');
                if (dateGroup) {
                    dateGroup.classList.add('is-invalid');
                }
                if (!blocked) {
                    const scrollTarget = (dateSelect.closest('.card-section'))
                        || dateSection
                        || dateSelect;
                    scrollTarget.scrollIntoView(true);
                }
                blocked = true;
                return;
            }

            if (hasValidated) {
                return;
            }

            // Case B: PAC/STAC/phone typed but Validate not clicked yet.
            const validateError = nsForm.querySelector('[data-network-switching-validate-error]');
            if (!validateError) {
                return;
            }
            validateError.removeAttribute('hidden');
            validateError.style.display = '';
            const parent = validateError.parentElement;
            if (parent) {
                parent.setAttribute('data-has-hidden', 'false');
            }
            if (!blocked) {
                const scrollTarget = validateError.closest('.card-section') || validateError;
                scrollTarget.scrollIntoView(true);
            }
            blocked = true;
        });
        return blocked;
    };
    // Dedupe networkSwitchingDecision inputs in basket-form right before submit.
    // form_rest() emits a stale hidden copy from the DB value, and the basket
    // sticky/footer render adds another — keep only our explicit mirror so a
    // single, correct value is posted.
    const dedupeNetworkSwitchingDecisionInputs = () => {
        try {
            const form = document.querySelector('form#basket-form');
            if (!form) {
                return;
            }
            const byName = {};
            // Only dedup hidden inputs (mirrors + form_rest copies). Radio buttons
            // share the same name by design and must not be removed — only the
            // checked one submits a value, so they self-dedup on submit.
            form.querySelectorAll('input[type="hidden"][name*="[networkSwitchingDecision]"]').forEach((input) => {
                (byName[input.name] = byName[input.name] || []).push(input);
            });
            document.querySelectorAll('input[type="hidden"][form="basket-form"][name*="[networkSwitchingDecision]"]').forEach((input) => {
                const list = (byName[input.name] = byName[input.name] || []);
                if (!list.includes(input)) {
                    list.push(input);
                }
            });
            Object.values(byName).forEach((inputs) => {
                if (inputs.length <= 1) {
                    return;
                }
                const mirror = inputs.find(i => i.hasAttribute('data-network-switching-decision-mirror'));
                // Only keep the mirror when it has a non-empty value; otherwise
                // fall back to the last rendered input (radios/form_rest), which
                // carries the user's current selection on first basket render.
                const keep = (mirror && mirror.value !== '') ? mirror : inputs[inputs.length - 1];
                inputs.forEach((input) => {
                    if (input !== keep && input.parentNode) {
                        input.parentNode.removeChild(input);
                    }
                });
            });
        } catch (err) {
            // Never let dedupe block submit.
        }
    };
    // Basket page CTA path
    checkoutButtons.forEach(checkoutButton =>
        checkoutButton.addEventListener('click', (e) => {
            if (hasBillCappingOrAccessibilityErrors()) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            if (hasNetworkSwitchingNotValidated()) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            dedupeNetworkSwitchingDecisionInputs();
            const liveSubmitBtn = document.querySelector('form#basket-form [type="submit"]')
                || document.querySelector('form#basket-form button');
            if (liveSubmitBtn) {
                liveSubmitBtn.click();
            }
        })
    );
    // Details-step / any page where #basket-form is submitted directly.
    // Delegate from document in CAPTURE phase so we:
    //   1) run BEFORE form-submit-once.js click handler and BEFORE the
    //      jQuery-delegated insurance handler that triggers the
    //      /basket/deal/validation AJAX + window.location.reload(),
    //   2) survive AJAX re-renders of the basket markup (the button node
    //      gets swapped, so a direct addEventListener would be lost).
    document.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('#basket-form [type="submit"]');
        if (!btn) {
            return;
        }
        const form = document.querySelector('form#basket-form');
        const billCap = hasBillCappingOrAccessibilityErrors();
        const nsNotValidated = hasNetworkSwitchingNotValidated();
        // On Click & Collect baskets the required switchingDate <select> is
        // hidden, so reportValidity() would scroll to / try to focus a
        // non-focusable control. Skip it in that case.
        const hasCcNs = !!document.querySelector('[data-network-switching-cc="true"]');
        if (billCap || nsNotValidated) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (!nsNotValidated && !hasCcNs && form && typeof form.reportValidity === 'function') {
                form.reportValidity();
            }
            return false;
        }
        dedupeNetworkSwitchingDecisionInputs();
    }, true);
    window.addEventListener('scroll', () => {
        backToTop.classList.toggle(
            'hide',
            window.pageYOffset < header.offsetTop + header.offsetHeight
        );
    });
    backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    // CPW-5063 starts
    // Run on window resize
    $(window).resize(function() {
        toggleFooterCTA();
        balanceProductImageandDetails();
    });
    // CPW-5063 ends
    function toggleFooterCTA() {
        const $mainCTA = $('.main-checkout-cta');
        const $footerCTA = $('.footer-checkout-cta');
        const $footerSpace = $('.basket-footer-panel');

        if (!$mainCTA.length) {
            return;
        }

        const fullyOut = isElementFullyOutOfView($mainCTA);
        if (fullyOut) {
            $footerCTA.addClass('visible');
            $footerSpace.addClass('footer-spacing');
        } else {
            $footerCTA.removeClass('visible');
            $footerSpace.removeClass('footer-spacing');
        }
        if (window.innerWidth > 767) {
            if ($('.buttonSubmitSidebar').length) {
                $('.basket-sticky-container .buttonSubmitSidebar').attr('style', 'width: ' + $('.main-checkout-cta .buttonSubmitSidebar').outerWidth(true) + 'px !important;');
            }
        } else {
            $('.basket-sticky-container .buttonSubmitSidebar').css('width', 'auto');
        }
    }
    function isElementFullyOutOfView($el) {
        if (!$el.length) {
            return false;
        }
        const rect = $el[0].getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return (
            rect.bottom < 0 || rect.top > windowHeight
        );
    }
    function balanceProductImageandDetails() {
        if ($('.product-image-box').length) {
            $('.product-image-box').each(function() {
                let $this = $(this);
                let dataRef = $this.attr('data-ref');
                let minHeight = (window.innerWidth > 1023) ? 132 : ((window.innerWidth < 768) ? 94 : 116);
                $this.attr('style', 'min-height: ' + minHeight + 'px !important;');
                if ($('.nonSim' + dataRef).length) {
                    $('.nonSim' + dataRef).attr('style', 'min-height: ' + minHeight + 'px !important;');
                    let imgBox = $this.outerHeight(true);
                    let nonSim = $('.nonSim' + dataRef).outerHeight(true);
                    if ($('.priceSim' + dataRef).length) {
                        $('.priceSim' + dataRef).attr('style', 'min-height: ' + ((window.innerWidth > 767) ? (nonSim + 'px') : 'auto') + ' !important;');
                    }
                    if (nonSim > imgBox) {
                        $this.attr('style', 'min-height: ' + nonSim + 'px !important;');
                    }
                    if (imgBox > nonSim) {
                        $('.nonSim' + dataRef).attr('style', 'min-height: ' + imgBox + 'px !important;');
                    }
                }
            });
        }
    }
    function formatNetworkSwitchingDate(isoDate) {
        const [year, month, day] = isoDate.split('-').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day));
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC',
        });
    }
    function syncInsuranceMargin(summaryEl, nsVisible) {
        const marginClass = summaryEl && summaryEl.dataset.nsInsuranceSpacing;
        if (!marginClass) {
            return;
        }
        const parent = summaryEl.parentElement;
        if (!parent) {
            return;
        }
        const insuranceDiv = parent.querySelector('.order-summary__product-mobile-insurance');
        if (!insuranceDiv) {
            return;
        }
        insuranceDiv.classList.toggle(marginClass, !nsVisible);
    }
    function showBriefLoader() {
        const overlay = document.querySelector('[data-loading-overlay]');
        if (!overlay) {
            return;
        }
        const current = parseInt(overlay.dataset.activeTasks || '0');
        overlay.dataset.activeTasks = current + 1;
        setTimeout(() => {
            const tasks = parseInt(overlay.dataset.activeTasks || '0');
            if (tasks > 0) {
                overlay.dataset.activeTasks = tasks - 1;
            }
        }, 400);
    }
    function initNetworkSwitchingDateSummarySync() {
        document.querySelectorAll('[data-network-switching-available-dates]').forEach((select) => {
            // Extract deal line ID from name: "form[deal-xxx-networkSwitching][switchingDate]"
            const match = select.name.match(/\[(.+?)-networkSwitching\]/);
            if (!match) {
                return;
            }

            const dealLineId = match[1];
            const summaryP = document.querySelector(`[data-network-switching-summary="${dealLineId}"]`);

            if (!summaryP) {
                return;
            }

            select.addEventListener('change', () => {
                if (!select.value) {
                    summaryP.classList.add('hide');
                    syncInsuranceMargin(summaryP, false);
                    return;
                }
                showBriefLoader();
                // Reveal the paragraph if it was hidden (first-time date selection)
                summaryP.classList.remove('hide');
                syncInsuranceMargin(summaryP, true);
                const actionEl = summaryP.querySelector('[data-ns-action]');
                if (actionEl) {
                    // Derive action from the checked decision radio for this deal line
                    const decisionForm = select.closest('[data-network-switching]');
                    if (decisionForm) {
                        const checked = decisionForm.querySelector('[data-network-switching-decision] input[type="radio"]:checked');
                        if (checked) {
                            actionEl.textContent = checked.value === 'pac' ? 'transfer' : 'cancel';
                        }
                    }
                }
                const latestDateEl = summaryP.querySelector('[data-ns-date]');
                if (latestDateEl) {
                    latestDateEl.textContent = formatNetworkSwitchingDate(select.value);
                }
            });

            // Initial sync: if the dropdown has no selected date on page load,
            // hide the NS paragraph regardless of server-rendered state.
            if (!select.value) {
                summaryP.classList.add('hide');
                syncInsuranceMargin(summaryP, false);
            }
        });

        // Click & Collect baskets have no date dropdown, so wire the same
        // summary reveal to the form state transition into 'edit'
        // (set by network-switching/index.js once validation succeeds).
        document.querySelectorAll('[data-network-switching-cc="true"]').forEach((form) => {
            const publicIdInput = form.querySelector('input[name="publicId"]');
            const dealLineId = publicIdInput ? publicIdInput.value : null;
            if (!dealLineId) {
                return;
            }
            const summaryP = document.querySelector(`[data-network-switching-summary="${dealLineId}"]`);
            if (!summaryP) {
                return;
            }

            const syncCcSummary = () => {
                const state = form.dataset.networkSwitchingFormState;
                const decisionChecked = form.querySelector('[data-network-switching-decision] input[type="radio"]:checked');
                const decisionValue = decisionChecked ? decisionChecked.value : null;
                if (state !== 'edit' || !decisionValue || decisionValue === 'no') {
                    summaryP.classList.add('hide');
                    syncInsuranceMargin(summaryP, false);
                    return;
                }
                showBriefLoader();
                summaryP.classList.remove('hide');
                syncInsuranceMargin(summaryP, true);
                const actionEl = summaryP.querySelector('[data-ns-action]');
                if (actionEl) {
                    actionEl.textContent = decisionValue === 'pac' ? 'transfer' : 'cancel';
                }
            };

            // Initial sync (e.g. page reload after consent already given).
            syncCcSummary();

            const observer = new MutationObserver(syncCcSummary);
            observer.observe(form, {
                attributes: true,
                attributeFilter: ['data-network-switching-form-state'],
            });

            // Hide again if user flips decision back to "no" / a different one.
            form.querySelectorAll('[data-network-switching-decision] input[type="radio"]').forEach((radio) => {
                radio.addEventListener('change', () => {
                    if (radio.checked && radio.value === 'no') {
                        summaryP.classList.add('hide');
                        syncInsuranceMargin(summaryP, false);
                    }
                });
            });
        });
    }
    function initBillCapOrderSummarySync() {
        // Intercept the shared lib's native XHR for /basket/bill-capping so we can
        // react to the response without making a second AJAX call.
        if (!window._billCapXhrIntercepted) {
            window._billCapXhrIntercepted = true;
            const origOpen = XMLHttpRequest.prototype.open;
            const origSend = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.open = function(method, url) {
                if (method === 'POST' && url === '/basket/bill-capping') {
                    this._isBillCap = true;
                }
                return origOpen.apply(this, arguments);
            };

            XMLHttpRequest.prototype.send = function(body) {
                if (this._isBillCap) {
                    const params = new URLSearchParams(body || '');
                    const publicId = params.get('publicId');
                    this.addEventListener('load', function() {
                        try {
                            const response = JSON.parse(this.responseText);
                            document.dispatchEvent(new CustomEvent('billCapXhrDone', {
                                detail: {
                                    publicId,
                                    response,
                                },
                            }));
                        } catch (e) {
                            // ignore JSON parse errors
                        }
                    });
                }
                return origSend.apply(this, arguments);
            };
        }

        document.querySelectorAll('[data-bill-capping-basket-section]').forEach((section) => {
            const dealLineId = section.dataset.dealLinePublicId;
            const summaryValueEl = document.querySelector(`[data-bill-cap-summary="${dealLineId}"] .order-summary__product-pricing-value`);
            if (!summaryValueEl) {
                return;
            }
            const amountSelect = section.querySelector('[data-bill-capping-amount]');

            function getSummaryDisplayValue() {
                const checked = section.querySelector('[data-bill-capping-decision] input[type="radio"]:checked');
                if (!checked || checked.value === '0') {
                    return 'No bill cap';
                }
                if (amountSelect && amountSelect.value) {
                    return '£' + parseFloat(amountSelect.value).toFixed(2);
                }
                return null;
            }

            document.addEventListener('billCapXhrDone', function(e) {
                if (e.detail.publicId !== dealLineId) {
                    return;
                }
                if (e.detail.response.result === 'success') {
                    const displayValue = getSummaryDisplayValue();
                    if (displayValue !== null) {
                        summaryValueEl.textContent = displayValue;
                    }
                }
            });
        });
    }
    $(document).ready(function() {
        toggleFooterCTA();
        balanceProductImageandDetails();
        initBillCapOrderSummarySync();
        initNetworkSwitchingDateSummarySync();
        if ($('.revalidationPath').length) {
            $(document).on('show.bs.modal', '.basketNoInsuranceSelected', function() {
                let dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'view',
                    'view_name': 'mobile insurance not selected',
                    'view_type': 'popup'
                });
            });
            $('.removeBasketDeal').each(function() {
                let dataRef = $(this).attr('data-basket-line');
                if ($('#form_' + dataRef + '-networkSwitching_networkSwitchingDecision_0').length) {
                    $('#form_' + dataRef + '-networkSwitching_networkSwitchingDecision_0').prop('checked', true);
                }
            });
            $(document).on('click', '.buttonSubmitSidebar', function() {
                $('.form-submit').click();
            });
            $(window).on('scroll resize', toggleFooterCTA);
            toggleFooterCTA();
        }
        if ($('.form-fieldset-bill-cap').length) {
            let toggles = document.querySelectorAll('.toggle-switch input');
            toggles.forEach(function(toggle) {
                let card = toggle.closest('.card-header').parentElement;
                let cardBody = card.querySelector('.card-body');
                toggle.addEventListener('change', function() {
                    let slider = this.nextElementSibling;
                    let dataSection = slider.getAttribute('data-section');
                    let dataRef = slider.getAttribute('data-ref');
                    let noToggleSection = card.querySelector('.no' + dataSection + dataRef);
                    cardBody.classList.toggle('hidden', !this.checked);
                    noToggleSection.classList.toggle('hide', this.checked);
                    if (dataSection == 'billCappingDecision') {
                        $('#form_' + dataRef + '_billCappingDecision_' + ((this.checked) ? '1' : '0')).click();
                    }
                    if (dataSection == 'accessibilityDecision') {
                        $('#form_' + dataRef + '-accessibility_accessibilityDecision_' + ((this.checked) ? '1' : '0')).click();
                    }
                    if (dataSection == 'networkSwitchingDecision') {
                        // Always default to "Get a new number" (index 0)
                        // User must explicitly click PAC/STAC to show consent section
                        let radioIndex = 0;

                        let radio = document.querySelector('#form_' + dataRef + '-networkSwitching_networkSwitchingDecision_' + radioIndex);
                        if (radio) {
                            radio.click();
                        }

                        if (!this.checked) {
                            // Toggle turned OFF — hide the network switching summary line
                            const summaryEl = document.querySelector('[data-network-switching-summary="' + dataRef + '"]');
                            if (summaryEl) {
                                summaryEl.classList.add('hide');
                                syncInsuranceMargin(summaryEl, false);
                            }
                        }
                    }
                });
            });

            // Initialize network switching toggles on page load
            toggles.forEach(function(toggle) {
                let card = toggle.closest('.card-header').parentElement;
                let cardBody = card.querySelector('.card-body');
                let slider = toggle.nextElementSibling;
                let dataSection = slider.getAttribute('data-section');
                let dataRef = slider.getAttribute('data-ref');

                if (dataSection == 'networkSwitchingDecision') {
                    // Check all radio buttons to find which one is checked
                    let radioIndex = 0;
                    let radio = document.querySelector('#form_' + dataRef + '-networkSwitching_networkSwitchingDecision_' + radioIndex);

                    while (radio) {
                        if (radio.checked && radio.value !== 'no') {
                            // Found a checked radio that's not "no", so toggle should be ON
                            toggle.checked = true;
                            cardBody.classList.remove('hidden');
                            break;
                        }
                        radioIndex++;
                        radio = document.querySelector('#form_' + dataRef + '-networkSwitching_networkSwitchingDecision_' + radioIndex);
                    }

                    // Update the toggle info text visibility
                    let noToggleSection = card.querySelector('.no' + dataSection + dataRef);
                    if (noToggleSection) {
                        noToggleSection.classList.toggle('hide', toggle.checked);
                    }
                }
            });

            // Initialize consent checkbox and validated form state on page load
            $('[data-network-switching-consent]').each(function() {
                const $consentCheckbox = $(this);
                const $currentForm = $consentCheckbox.closest('[data-network-switching]');
                const formState = $currentForm.attr('data-network-switching-form-state');
                const dataRef = $consentCheckbox.attr('data-ref');

                const $pacCode = $currentForm.find('#form_' + dataRef + '-networkSwitching_networkSwitchingPacCode');
                const $stacCode = $currentForm.find('#form_' + dataRef + '-networkSwitching_networkSwitchingStacCode');
                const $phoneNumber = $currentForm.find('#form_' + dataRef + '-networkSwitching_networkSwitchingMobileNumber');

                // If form is in edit state (validated), restore the validated UI state
                if (formState === 'edit' || $pacCode.val() || $stacCode.val() || $phoneNumber.val()) {
                    // Check the consent checkbox
                    $consentCheckbox.prop('checked', true);

                    // Show the PAC/STAC content section
                    const $pacStacSection = $currentForm.find('.pacStac' + dataRef);
                    $pacStacSection.removeClass('hide');
                    $pacStacSection.attr('data-has-hidden', false);

                    // Enable ALL form groups - find any element with data-has-disabled inside the form
                    $currentForm.find('[data-has-disabled]').attr('data-has-disabled', false);

                    // Make input fields readonly and not disabled
                    $pacCode.prop('disabled', false).prop('readonly', true);
                    $stacCode.prop('disabled', false).prop('readonly', true);
                    $phoneNumber.prop('disabled', false).prop('readonly', true);

                    // If JS earlier in init cleared the mobile input but the
                    // server-rendered HTML attribute still carries the value
                    // (e.g. arriving on /basket/details via POST→redirect from
                    // /basket "Go to checkout"), restore it from the attribute.
                    if (!$phoneNumber.val()) {
                        const renderedMobile = $phoneNumber.attr('value') || '';
                        if (renderedMobile) {
                            $phoneNumber.val(renderedMobile);
                        }
                    }

                    // Seed per-option saved-mobile so a PAC↔STAC switch can
                    // restore the originally-validated mobile number.
                    const seedMobile = $phoneNumber.val() || '';
                    if (seedMobile) {
                        if ($pacCode.val()) {
                            $currentForm
                                .find('[data-network-switching-type="pac"]')
                                .attr('data-saved-mobile', seedMobile);
                        }
                        if ($stacCode.val()) {
                            $currentForm
                                .find('[data-network-switching-type="stac"]')
                                .attr('data-saved-mobile', seedMobile);
                        }
                    }

                    // Set the correct pac-input or spac-input class based on which code has a value
                    if ($pacCode.val()) {
                        $pacStacSection.removeClass('spac-input').addClass('pac-input');
                    } else if ($stacCode.val()) {
                        $pacStacSection.removeClass('pac-input').addClass('spac-input');
                    }

                    // Show Edit button, hide Validate button
                    const $validateBtn = $currentForm.find('[data-network-switching-button]');
                    const $editBtn = $currentForm.find('[data-network-switching-edit-button]');
                    $validateBtn.hide().attr('hidden', 'hidden');
                    $editBtn.show().removeAttr('hidden');

                    // Show the date dropdown section (unless this is a Click & Collect basket,
                    // in which case the server-rendered cc-info message replaces the date picker).
                    if ($currentForm.attr('data-network-switching-cc') !== 'true') {
                        const $dateSection = $currentForm.find('[data-network-switching-date]');
                        $dateSection.attr('data-has-hidden', false).removeAttr('hidden').show();
                    }
                }
            });

            // Initialize network switching date dropdowns on page load
            $('[data-network-switching-available-dates]').each(function() {
                const $dropdown = $(this);
                const selectedValue = $dropdown.val();

                // Remove selected from all options first
                $dropdown.find('option').prop('selected', false).removeAttr('selected');

                // Set selected if there's a real value
                if (selectedValue && selectedValue !== '') {
                    $dropdown.find('option[value="' + selectedValue + '"]').prop('selected', true).attr('selected', 'selected');
                }
            });

            // Handle network switching date change
            $(document).on('change', '[data-network-switching-available-dates]', function() {
                const $dropdown = $(this);
                const selectedValue = $dropdown.val();

                // Always remove selected from all options first
                $dropdown.find('option').prop('selected', false).removeAttr('selected');

                if (selectedValue !== '') {
                    // Set the selected attribute only on the chosen option
                    $dropdown.find('option[value="' + selectedValue + '"]').prop('selected', true).attr('selected', 'selected');

                    // Remove error when date is selected
                    $dropdown.closest('.form-group').removeClass('is-invalid');
                    $dropdown.closest('[data-network-switching-date]').find('.help-block').removeClass('is-invalid').hide();

                    // Commit point: user has validated + picked a date for the
                    // currently-selected option. Any preserved value on the
                    // OTHER option is stale (left over from earlier exploration)
                    // and should be wiped so a future radio-click to it starts
                    // fresh, not auto-checking consent with old code values.
                    const $currentForm = $dropdown.closest('[data-network-switching]');
                    const currentChoice = $currentForm
                        .find('[data-network-switching-decision] input[type="radio"]:checked')
                        .val();
                    if (currentChoice === 'pac' || currentChoice === 'stac') {
                        const otherChoice = currentChoice === 'pac' ? 'stac' : 'pac';
                        $currentForm
                            .find('[data-network-switching-type="' + otherChoice + '"]')
                            .val('')
                            .removeAttr('data-saved-mobile');
                    }
                }
            });

            // Show error when user clicks outside without selecting a date
            $(document).on('blur', '[data-network-switching-available-dates]', function() {
                const $dropdown = $(this);
                const selectedValue = $dropdown.val();
                const $dateContainer = $dropdown.closest('[data-network-switching-date]');
                const isVisible = $dateContainer.attr('data-has-hidden') !== 'true' && $dateContainer.is(':visible');

                // Only show error if date section is visible and no date is selected
                if (isVisible && (!selectedValue || selectedValue === '')) {
                    $dropdown.closest('.form-group').addClass('is-invalid');
                    $dateContainer.find('.help-block').addClass('is-invalid').show();
                }
            });

            // Removed - this was overriding the initialization logic above and hiding validated fields
            // if ($('.pacStacDetails').length) {
            //     $('.pacStacDetails .form-group').attr('data-has-disabled', true);
            // }

            // Whenever the user types in the mobile field, stash the value on
            // the currently-selected option's code input as `data-saved-mobile`.
            // This keeps the per-option mobile snapshot up-to-date regardless of
            // radio-switch ordering or vendor-module state churn.
            $(document).on('input change', 'input[data-network-switching-phone-number]', function() {
                const $mobile = $(this);
                const $currentForm = $mobile.closest('[data-network-switching]');
                const currentChoice = $currentForm
                    .find('[data-network-switching-decision] input[type="radio"]:checked')
                    .val();
                if (currentChoice === 'pac' || currentChoice === 'stac') {
                    $currentForm
                        .find('[data-network-switching-type="' + currentChoice + '"]')
                        .attr('data-saved-mobile', $mobile.val() || '');
                }
            });

            // Commit hook: clicking Validate for one option discards any
            // preserved data for the other option, so a subsequent radio
            // switch to that other option starts fresh (no stale auto-restore).
            $(document).on('click', '[data-network-switching-button]', function() {
                const $btn = $(this);
                const $currentForm = $btn.closest('[data-network-switching]');
                const currentChoice = $currentForm
                    .find('[data-network-switching-decision] input[type="radio"]:checked')
                    .val();
                if (currentChoice === 'pac' || currentChoice === 'stac') {
                    const otherChoice = currentChoice === 'pac' ? 'stac' : 'pac';
                    $currentForm
                        .find('[data-network-switching-type="' + otherChoice + '"]')
                        .val('')
                        .removeAttr('data-saved-mobile');
                }
            });

            $(document).on('click', '[data-network-switching-decision] input[type="radio"]', function() {
                let networkSwitching = $(this).val();
                let nameAttr = $(this).attr('name');
                let baskeLine = nameAttr.split('[')[1].split('-networkSwitching')[0];

                // Scope all selectors to this specific basket line
                let currentForm = $(this).closest('[data-network-switching]');
                let pacStacSection = currentForm.find('.pacStac' + baskeLine);
                let networkSwitchingForm = currentForm.find('.networkSwitchingForm' + baskeLine);
                let pacStacConsent = currentForm.find('.pacStacConScent' + baskeLine);

                // Capture pre-click state. If the form was in 'edit' state
                // (the previously-selected option was successfully validated)
                // and the user now picks a different pac/stac option, the
                // previously-saved value on the newly-selected option is stale
                // (e.g. saved PAC value before user re-validated with STAC).
                // In that case clear it so the user starts fresh on the new
                // option. Reading attrs before setFieldsetsStates (which fires
                // on the native 'input' event) overwrites them.
                let previousState = currentForm.attr('data-network-switching-form-state');
                let previousChoice = currentForm.attr('data-network-switching-choice');
                let abandonedValidatedOption =
                    previousState === 'edit' &&
                    previousChoice &&
                    previousChoice !== networkSwitching &&
                    networkSwitching !== 'no';

                if (abandonedValidatedOption) {
                    // Clear the newly-selected option's code input so the user
                    // starts fresh on it. Keep the abandoned option's value so
                    // re-clicking it later restores the validated input.
                    currentForm
                        .find('[data-network-switching-type="' + networkSwitching + '"]')
                        .val('');
                    // Stash the mobile number on the abandoned option's code
                    // input so we can restore it if the user returns. Mobile
                    // is a shared input but logically belongs to whichever
                    // option was validated against it.
                    let $mobile = currentForm.find('input[data-network-switching-phone-number]');
                    currentForm
                        .find('[data-network-switching-type="' + previousChoice + '"]')
                        .attr('data-saved-mobile', $mobile.val() || '');
                    $mobile.val('');
                    if (pacStacConsent.is(':checked')) {
                        pacStacConsent.prop('checked', false).trigger('input');
                    }
                }

                // Do NOT clear PAC/STAC input values or force-toggle the consent
                // checkbox here. setFieldsetsStates() in network-switching/index.js
                // is the authoritative state owner: it enables the matching input,
                // re-checks consent when the matching input has a value, and puts
                // the form into 'validate' state. Wiping values here breaks the
                // PAC -> STAC -> PAC round-trip (saved PAC value would disappear).

                networkSwitchingForm.prop('disabled', (networkSwitching == 'no') ? true : false);
                pacStacConsent.prop('required', (networkSwitching == 'no') ? false : true);
                if (networkSwitching == 'pac') {
                    pacStacSection.removeClass('spac-input');
                    pacStacSection.addClass('pac-input');
                } else if (networkSwitching == 'stac') {
                    pacStacSection.removeClass('pac-input');
                    pacStacSection.addClass('spac-input');
                }

                if (networkSwitching == 'no') {
                    if (!pacStacSection.hasClass('hide')) {
                        pacStacSection.addClass('hide');
                    }
                    if (pacStacConsent.is(':checked')) {
                        pacStacConsent.prop('checked', false).trigger('input');
                    }
                } else {
                    // Re-selecting pac/stac: if the matching code input already has
                    // a value (user previously validated this option), auto-check
                    // the consent box, reveal the section, and expose the section
                    // contents so the Validate button is visible for re-validation.
                    let matchingInput = currentForm.find(
                        '[data-network-switching-type="' + networkSwitching + '"]'
                    );
                    if (matchingInput.length && matchingInput.val() !== '') {
                        if (!pacStacConsent.is(':checked')) {
                            pacStacConsent.prop('checked', true).trigger('input');
                        }
                        pacStacSection.removeClass('hide');
                        pacStacSection.attr('data-has-hidden', false);
                        // Restore the mobile number previously validated with
                        // this option (stashed when user switched away).
                        let savedMobile = matchingInput.attr('data-saved-mobile');
                        if (savedMobile) {
                            currentForm
                                .find('input[data-network-switching-phone-number]')
                                .val(savedMobile);
                        }
                    } else {
                        // Switching to a pac/stac option that has no saved value:
                        // clear mobile number and uncheck consent so the user
                        // starts fresh for this option (mobile + consent belonged
                        // to the previously-selected option).
                        currentForm.find('input[data-network-switching-phone-number]').val('');
                        if (pacStacConsent.is(':checked')) {
                            pacStacConsent.prop('checked', false).trigger('input');
                        }
                    }
                }
            });
            $(document).on('click', '.pacStacConScent', function() {
                let baskeLine = $(this).attr('data-ref');
                let currentForm = $(this).closest('[data-network-switching]');
                let pacStacSection = currentForm.find('.pacStac' + baskeLine);
                // Get the selected network switching option for THIS form
                let networkSwitching = currentForm.find('[data-network-switching-decision] input[type="radio"]:checked').val() || 'no';
                if ($(this).is(':checked')) {
                    if (pacStacSection.hasClass('hide')) {
                        pacStacSection.removeClass('hide');
                    }
                    pacStacSection.attr('data-has-hidden', false);
                    // Scope to current form only
                    if (currentForm.find('.' + networkSwitching + 'Details' + baskeLine).length) {
                        currentForm.find('.' + networkSwitching + 'Details' + baskeLine + ' .form-group').attr('data-has-disabled', false);
                        currentForm.find('.' + networkSwitching + 'Details' + baskeLine + ' input[type="text"]').prop('disabled', false);
                        currentForm.find('.' + networkSwitching + 'Details' + baskeLine + ' input[type="text"]').val('');
                        currentForm.find('.pacStacPhone' + baskeLine + ' .form-group').attr('data-has-disabled', false);
                        currentForm.find('.pacStacPhone' + baskeLine + ' input[type="text"]').prop('disabled', false);
                        currentForm.find('.pacStacPhone' + baskeLine + ' input[type="text"]').val('');
                    }
                } else {
                    if (!pacStacSection.hasClass('hide')) {
                        pacStacSection.addClass('hide');
                    }
                    pacStacSection.attr('data-has-hidden', true);
                    if (currentForm.find('.' + networkSwitching + 'Details' + baskeLine).length) {
                        currentForm.find('.' + networkSwitching + 'Details' + baskeLine + ' .form-group').attr('data-has-disabled', true);
                        currentForm.find('.' + networkSwitching + 'Details' + baskeLine + ' input[type="text"]').prop('disabled', true);
                        currentForm.find('.' + networkSwitching + 'Details' + baskeLine + ' input[type="text"]').val('');
                        currentForm.find('.pacStacPhone' + baskeLine + ' .form-group').attr('data-has-disabled', true);
                        currentForm.find('.pacStacPhone' + baskeLine + ' input[type="text"]').prop('disabled', true);
                        currentForm.find('.pacStacPhone' + baskeLine + ' input[type="text"]').val('');
                    }
                }
            });
        }
        if ($('.discountAccordionBillCap').length) {
            $(document).on('click', '.modal-body-title', function() {
                const target = $($(this).data('target'));
                $(this).toggleClass('accordion-open');
                target.toggleClass('open');
            });
        }
        if ($('.tradeInBasketButton').length) {
            $(document).on('click', '.tradeInBasketButton', function() {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'view',
                    'view_name': 'trade-in widget',
                    'view_type': 'popup',
                    'timeStamp': {
                        'timestampMs': Date.now(),
                        'isoTimestamp': new Date(Date.now()).toISOString()
                    }
                });
            });
        }
        $(document).on('focus mouseenter hover', '.viewDealsCta', function() {
            handleHrefUrl($(this));
        });
    });
}
if ($('.buttonSubmitSidebar').length) {
    $('.basket-sticky-container .buttonSubmitSidebar').attr('style', 'width: ' + $('.main-checkout-cta .buttonSubmitSidebar').outerWidth(true) + 'px !important;');
}
function handleHrefUrl($this) {
    let href = $this.attr('href');
    let orgHref = $this.attr('data-org-url');
    let dataHstarId = $this.attr('data-id');
    let hiddenAffiliateId = getCookie('hiddenAffiliateId');
    if (hiddenAffiliateId && hiddenAffiliateId != '') {
        hiddenAffiliateId = JSON.parse(atob(decodeURIComponent(hiddenAffiliateId)));
        if (hiddenAffiliateId.hstarid == dataHstarId) {
            $this.attr('href', hiddenAffiliateId.path);
        } else if (href != orgHref) {
            $this.attr('href', orgHref);
        }
    } else if (href != orgHref) {
        $this.attr('href', orgHref);
    }
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return '';
}
// Specific class for OS
document.addEventListener('DOMContentLoaded', () => {
    const platform = navigator.platform;
    if (platform.includes('Mac')) {
        document.body.classList.add('mac');
    } else if (platform.includes('Win')) {
        document.body.classList.add('windows');
    }
});
